import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  updatePassword(current_password, new_password, new_password_confirmation) {
    return RequesterV1.post("user_profile/change_data/update_password", {
      current_password: current_password,
      new_password: new_password,
      new_password_confirmation: new_password_confirmation
    });
  }
};
